module.exports = __webpack_public_path__ + "static/assets/67b5215a40ed284e31bd327d6303741d.png";